<!--
 * @Date: 2020-09-02 18:00:03
 * @Author: MX
 * @LastAuthor: WZ
 * @LastEditTime: 2021-7-21 17:01:06
 * @Description: 控制台 - 企业认证
-->
<template>
  <div class="companyAuth" :class="$i18n.locale">
    <h3>
      <i class="iconfont iconkongzhitai_qiyexinxirenzheng"></i>{{$lang('企业信息认证')}}
    </h3>
    <div class="audit-status">
      <div class="status"><i class="iconfont " :class="{ iconshenhezhuangtai_weishenqingshibai: auditStatus === ''|| auditStatus === 0 || auditStatus === 3, iconshenhezhuangtai_shenhezhong: auditStatus === 1, iconshenhezhuangtai_tongguo: auditStatus === 2}"></i>
      {{$lang("审核状态")}}：<span>{{auditStatus | statusFilter}}</span></div>
      <div class="reason" v-if="auditStatus === 3">{{$lang('失败原因')}}：<span :title="failReason">{{failReason}}</span></div>
    </div>
    <el-form ref="companyAuthForm" :rules="rules" label-width="180px" :model="companyAuthForm" label-suffix="：">
      <el-form-item prop="socialCreditCode" >
        <template slot="label">
          <span  :title="$lang('社会统一信用代码')">{{$lang('社会统一信用代码') + '：'}}</span>
        </template>
        <el-input :placeholder="$lang('请输入社会统一信用代码')" v-model="companyAuthForm.socialCreditCode" :disabled="isFirstPast||isCompanyEdit"></el-input>
      </el-form-item>
      <el-form-item prop="businessLicensePath" class="address">
        <template slot="label">
          <span  :title="$lang('营业执照')">{{$lang('营业执照') + '：'}}</span>
        </template>
        <div class="upload">
          <el-upload accept="image/jpeg,image/jpg,image/png" class="avatar-uploader" :headers="header" :action="actionUrl" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :disabled="isFirstPast||isCompanyEdit">
            <img v-if="businessLicenseImageUrl" :src="businessLicenseImageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <span class="text" v-if="!businessLicenseImageUrl">{{$lang('上传营业执照')}}</span>
        </div>
        <div class="upload-dec">{{$lang('支持所有图片格式，文件大小不超过5M')}} <i class="iconfont iconicotishi" @mouseover="mouseoverBusiness" @mouseleave="mouseleaveBusiness">{{$lang('示例')}}</i></div>
        <div class="example-business" v-show="isShow"  @mouseover="mouseoverBusiness" @mouseleave="mouseleaveBusiness">
          <div class="img-box">
            <a :href="require('../../assets/images/home/business2.png')"
             target="_blank"><img src="../../assets/images/home/business2.png" :alt="$lang('示例图片')"></a>
          </div>
          <div class="explain">
            <p>{{$lang(`1.请上传三证合一证清晰彩色扫描件或数码照片`)}}</p>
            <p>{{$lang(`2.证件请在有效期内，且年检通过`)}}</p>
            <p>{{$lang(`3.印章必须齐全（当年成立的可无年检章)`)}}</p>
            <p>{{$lang(`4.证件需要是由中国大陆工商局或者市场监督管理局颁发`)}}</p>
            <p>{{$lang(`5.支持jpeg、png、jpg格式`)}}</p>
          </div>
        </div>
      </el-form-item>
      <h3 style="margin-top:51px">
        <i class="iconfont iconkongzhitai_farenxinxi"></i>{{$lang(`法人信息`)}}
      </h3>
      <el-form-item prop="corporationName">
        <template slot="label">
          <span  :title="$lang('身份证姓名')">{{$lang('身份证姓名') + '：'}}</span>
        </template>
        <el-input :placeholder="$lang('请输入法人姓名')" v-model.trim="companyAuthForm.corporationName" :disabled="isFirstPast||isCompanyEdit"></el-input>
      </el-form-item>
      <el-form-item prop="corporationCardId" >
        <template slot="label">
          <span  :title="$lang('身份证号码')">{{$lang('身份证号码') + '：'}}</span>
        </template>
        <el-input :placeholder="$lang('请输入法人身份证号码')" v-model.trim="companyAuthForm.corporationCardId"  :disabled="isFirstPast||isCompanyEdit"></el-input>
      </el-form-item>
      <el-form-item class="address" prop="receiveAddress">
        <template slot="label">
          <span  :title="$lang('身份证地址')">{{$lang('身份证地址') + '：'}}</span>
        </template>
            <BaseAddress ref="receiverProvinceSearch" :initAddressData="receiverAddressData2" :showLevel="3" v-model="companyAuthForm.receiveAddress" :disabled="isFirstPast||isCompanyEdit">
            </BaseAddress>
        <!-- <el-select :placeholder="$t('controlPage.请输入酋长国')" v-model="companyAuthForm.corporationProvinceName" :disabled="isFirstPast||isCompanyEdit" @change="dataProvinceChange($event)" filterable :title="companyAuthForm.corporationProvinceName">
          <el-option
            v-for="item in provinceArray"
            :key="item.id"
            :label="item.nativeName"
            :value="item.id"
          />
        </el-select>
        <el-select :placeholder="$t('controlPage.请输入区域')" v-model="companyAuthForm.corporationCityName" :disabled="isFirstPast||isCompanyEdit" style="margin-left: 10px;" @change="dataCityChange($event)" filterable :title="companyAuthForm.corporationCityName">
          <el-option
            v-for="item in cityList"
            :key="item.id"
            :label="item.nativeName"
            :value="item.id"
          />
        </el-select> -->
      </el-form-item>
      <el-form-item prop="corporationDetailedAddress">
        <template slot="label">
          <span  :title="$t('controlPage.身份证详细地址')">{{$t('controlPage.身份证详细地址') + '：'}}</span>
        </template>
        <el-input class="input" v-model="companyAuthForm.corporationDetailedAddress"  :placeholder="$lang('请输入详细地址')" :disabled="isFirstPast||isCompanyEdit" :title="companyAuthForm.corporationDetailedAddress"></el-input>
      </el-form-item>
      <el-form-item prop="corporationPhotoPath" class="address">
        <template slot="label">
          <span  :title="$lang('身份证照片')">{{$lang('身份证照片') + '：'}}</span>
        </template>
        <div class="upload">
          <el-upload class="avatar-uploader" accept="image/jpeg,image/jpg,image/png" :headers="header" :action="actionUrl" :show-file-list="false" :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload" :disabled="isFirstPast||isCompanyEdit">
            <img v-if="idCardImageUrl" :src="idCardImageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <span class="text" v-if="!idCardImageUrl">{{$lang('上传身份证正面')}}</span>
        </div>
        <div class="upload ml20">
          <el-upload class="avatar-uploader" accept="image/jpeg,image/jpg,image/png" :headers="header" :action="actionUrl" :show-file-list="false" :on-success="handleAvatarSuccess3" :before-upload="beforeAvatarUpload" :disabled="isFirstPast||isCompanyEdit">
            <img v-if="idCardBackImageUrl" :src="idCardBackImageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <span class="text" v-if="!idCardBackImageUrl">{{$lang('上传身份证背面')}}</span>
        </div>
        <div class="upload-dec">{{$lang('支持所有图片格式，文件大小不超过5M')}} <i class="iconfont iconicotishi" @mouseover="mouseoverId" @mouseleave="mouseleaveId">{{$lang('示例')}}</i></div>
        <div :class="{'example-id': auditStatus !== 2, 'example-id2': auditStatus === 2}" v-show="isShow2"  @mouseover="mouseoverId" @mouseleave="mouseleaveId">
          <div class="img-box flex justify_between">
            <img src="../../assets/images/home/idCard2.png" :alt="$lang('示例图片')">
            <img src="../../assets/images/home/idCardBack2.png" :alt="$lang('示例图片')">
          </div>
          <div class="explain">
            <p>{{$lang("1.请上传身份证带有头像面的照片")}} </p>
            <p>{{$lang(`2.请上传身份证带有国徽的照片`)}} </p>
            <p>{{$lang(`3.请确保证件两面完整，图像清晰、字体清晰，证件号码清晰可见`)}}</p>
            <p>{{$lang(`4.支持jpeg、png、jpg格式`)}}</p>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <!-- 认证完成。这里都不能改 -->
    <div v-if="auditStatus !== 2">
      <!-- 用户初次认证，是提交按钮，还有一种情况是auditStatus 是 ''-->
      <button v-if="auditStatus === 0 || !auditStatus" class="commonBtn nextStep" :disabled="isFirstPast||isCompanyEdit" @click="submit">{{ $lang('提交') }}</button>
      <div v-else>
        <button v-if="isCompanyEdit" class="commonBtn nextStep" @click="openEdit">{{ $lang('修改') }}</button>
        <div v-else style="margin-top: 28px;">
          <button class="commonBtn back" @click.prevent="backStep">
            {{ $lang('返回') }}
          </button>
          <button class="commonBtn save" :disabled="isFirstPast||isCompanyEdit" @click="submit">{{ $lang('保存') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import { RESPONSE_SUCCESS } from "@/constants";
import { UPLOADUMG } from "@/api";
import {lang} from "@utils/filters"
import BaseAddress from "@/components/BaseAddress";

export default {
  name: "CompanyAuth",
  components: { BaseAddress },
  props: {
    addressOptions: {
      type: Array,
      default: () => {
        return [];
      },
    },
    getFirsting: {
      type: Boolean,
    },
    companyAuthFormSend: {
      type: Object,
      default: () => {
        return {};
      },
    },
    auditStatus: {},
    authLevel: {
      type: Number,
    },
    failReason: {
      type: String,
    },
    firstPast: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    companyEdit: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      actionUrl: UPLOADUMG,
      businessLicenseImageUrl: "", //营业执照照片
      idCardImageUrl: "", //身份证正面照片
      idCardBackImageUrl: "", //身份证正面照片
      cardList: [], //身份证照片列表 0 为 正面 1为反面
      provinceArray: [],
      cityList: [],
      companyAuthForm: {
        socialCreditCode: "", //社会信用代码
        businessLicensePath: "", //企业工商执照影印件
        corporationName: "", //法人姓名
        corporationCardId: "", //身份证
        corporationProvinceId: "", //省
        corporationProvinceName: "",
        corporationCityId: "", //市
        corporationCityName: "",
        corporationDetailedAddress: "", //详细地址
        corporationPhotoPath: "", //身份证照片
        receiveAddress: {},
      },
      rules: {
        socialCreditCode: [
          {
            required: true,
            message: this.$t('controlPage.请输入社会信用代码'),
            trigger: ["blur", "change"],
          },
        ],
        businessLicensePath: [
          {
            required: true,
            message: this.$t('controlPage.请上传营业执照'),
            trigger: ["blur", "change"],
          },
        ],
        corporationName: [
          {
            required: true,
            message: lang("请输入法人姓名"),
            trigger: ["blur", "change"],
          },
        ],
        corporationCardId: [
          {
            required: true,
            message: this.$t('controlPage.请输入法人身份证'),
            trigger: ["blur", "change"],
          },
        ],
        receiveAddress: [
          {
            required: true,
            validator: this.receiveAddress,
            trigger: ["blur", "change"],
          },
        ],
        corporationDetailedAddress: [
          {
            required: true,
            message: lang("请输入详细地址"),
            trigger: ["blur", "change"],
          },
        ],
        corporationPhotoPath: [
          {
            required: true,
            validator: this.validateCardPath,
            trigger: ["blur", "change"],
          },
        ],
      },
      isShow: false, // 商业执照示例
      isShow2: false, // 身份证示例
      isFirstPast: false, // 用户没有提交开发者认证进入
      isCompanyEdit: false, // 用户修改的开关
      receiverAddressData2: {
        //法人地址
        formProps: {
          provinceIdProp: "corporationProvinceId",
          provinceNameProp: "corporationProvinceName",
          cityIdProp: "corporationCityId",
          cityNameProp: "corporationCityName",
          areaIdProp: "corporationAreaId",
          areaNameProp: "corporationAreaName",
        },
        defaultData: {},
      },
    };
  },
  computed: {
    ...mapGetters(["user", "token"]),
    header() {
      return {
        authToken: this.token,
      };
    },
  },
  created() {
    this.$emit("pageActive");
  },
  watch: {
    companyAuthFormSend: {
      deep: true, // 深度监听
      immediate: true, // 监听到后，立即执行 handler方法
      handler(val) {
        console.log(val)
        // 有变化
        const {
          socialCreditCode,
          businessLicensePath,
          corporationName,
          corporationCardId,
          corporationProvinceId,
          corporationProvinceName,
          corporationCityId,
          corporationCityName,
          corporationAreaId,
          corporationAreaName,
          corporationDetailedAddress,
          corporationPhotoPath,
          receiveAddress,
        } = val;
        this.companyAuthForm.socialCreditCode = socialCreditCode;
        this.companyAuthForm.businessLicensePath = businessLicensePath;
        this.companyAuthForm.corporationName = corporationName;
        this.companyAuthForm.corporationCardId = corporationCardId;
        this.companyAuthForm.corporationProvinceId = corporationProvinceId;
        this.companyAuthForm.corporationProvinceName = corporationProvinceName;
        this.companyAuthForm.corporationCityId = corporationCityId;
        this.companyAuthForm.corporationCityName = corporationCityName;
        this.companyAuthForm.corporationAreaId = corporationAreaId;
        this.companyAuthForm.corporationAreaName = corporationAreaName;
        this.companyAuthForm.corporationDetailedAddress =
          corporationDetailedAddress;
        this.companyAuthForm.corporationPhotoPath = corporationPhotoPath;
        this.companyAuthForm.receiveAddress = receiveAddress;
        if (businessLicensePath && businessLicensePath.length > 0) {
          // 如果营业执照有路径
          this.$API.getImgUrl({ path: businessLicensePath }).then((res) => {
            this.businessLicenseImageUrl = res.data[0] || "";
            this.$refs.companyAuthForm.validateField("businessLicensePath");
          });
        }
        if (corporationPhotoPath && corporationPhotoPath.length > 0) {
          // 如果身份证照片有路径，正方面在一起
          //身份证正面照片
          let params1 = {
            path: corporationPhotoPath.split(",")[0] || "",
          };
          this.$API.getImgUrl(params1).then((res) => {
            this.idCardImageUrl = res.data[0] || "";
          });
          //身份证反面照片
          let params2 = {
            path: corporationPhotoPath.split(",")[1] || "",
          };
          this.$API.getImgUrl(params2).then((res) => {
            this.idCardBackImageUrl = res.data[0] || "";
          });
          this.cardList[0] = corporationPhotoPath.split(",")[0];
          this.cardList[1] = corporationPhotoPath.split(",")[1];
        }
        // 酋长国列表赋予
        if(this.addressOptions && this.addressOptions.length > 0) {
          this.provinceArray = [...this.addressOptions]
        } else {
          console.log('重新请求')
          // 需要重新请求
          let params = {
            parentId: "1",
            type: "2",
          };
          const formData = new FormData();
          Object.keys(params).forEach((key) => {
            formData.append(key, params[key]);
          });
          this.$API.areaList(formData).then((res) => {
            if (res.code === RESPONSE_SUCCESS) {
              // 酋长国获取列表
              this.provinceArray = [...res.data]
            } else {
              this.$message.error(res.msg);
            }
          });
        }
        // 区域地址回显，如果有
        if(corporationProvinceId) {
          let params = {
            parentId: corporationProvinceId,
            type: "3",
          };
          const formData = new FormData();
          Object.keys(params).forEach((key) => {
            formData.append(key, params[key]);
          });
          this.$API.areaList(formData).then((res) => {
            if (res.code === RESPONSE_SUCCESS) {
              // 区域获取列表
              this.cityList = [...res.data]
            } else {
              console.log('触发了这段代码')
              this.$message.error(res.msg);
            }
          })
        }

                // 地址回显
        this.receiverAddressData2.defaultData = {
          corporationProvinceId: corporationProvinceId || "",
          corporationProvinceName: corporationProvinceName || "",
          corporationCityId: corporationCityId || "",
          corporationCityName: corporationCityName || "",
          corporationAreaId: corporationAreaId || "",
          corporationAreaName: corporationAreaName || "",
        };
      },
    },
    firstPast: {
      deep: true, // 深度监听
      immediate: true, // 监听到后，立即执行 handler方法
      handler(val) {
        this.isFirstPast = val;
      },
    },
    companyEdit: {
      deep: true, // 深度监听
      immediate: true, // 监听到后，立即执行 handler方法
      handler(val) {
        this.isCompanyEdit = val;
      },
    },
  },
  filters: {
    statusFilter(val) {
      const myMap = new Map([
        [1, "审核中"],
        [2, "认证通过"],
        [3, "认证不通过"],
      ]);
      return myMap.get(val) ? lang(myMap.get(val)) : lang("未申请");
    },
  },
  methods: {
    /**
     * @description 鼠标事件
     */
    mouseoverBusiness() {
      clearTimeout(this.timer);
      this.isShow = true;
    },
    // 移出
    mouseleaveBusiness() {
      this.timer = setTimeout(() => {
        this.isShow = false;
      }, 100);
    },
    mouseoverId() {
      clearTimeout(this.timer2);
      this.isShow2 = true;
    },
    mouseleaveId() {
      this.timer2 = setTimeout(() => {
        this.isShow2 = false;
      }, 100);
    },
    /**
     * @description 上传前
     */
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error(this.$lang("请上传后缀为.jpeg|.png|.jpg的图片文件"));
        return false;
      }
      if (!isLt2M) {
        this.$message.error(this.$lang("上传图片大小不能超过 5MB!"));
        return false;
      }
      return isJPG && isLt2M;
    },
    /**
     * @description 营业执照上传成功回调
     */
    handleAvatarSuccess(res) {
      this.companyAuthForm.businessLicensePath = res.data;
      this.$API.getImgUrl({ path: res.data }).then((res) => {
        this.businessLicenseImageUrl = res.data[0] || "";
        this.$refs.companyAuthForm.validateField("businessLicensePath");
      });
    },
    /**
     * @description 身份证正面上传成功回调
     */
    handleAvatarSuccess2(res) {
      this.cardList[0] = res.data;
      this.$API.getImgUrl({ path: res.data }).then((res) => {
        this.idCardImageUrl = res.data[0] || "";
        this.$refs.companyAuthForm.validateField("corporationPhotoPath");
      });
    },
    /**
     * @description 身份证反面上传成功回调
     */
    handleAvatarSuccess3(res) {
      this.cardList[1] = res.data;
      this.$API.getImgUrl({ path: res.data }).then((res) => {
        this.idCardBackImageUrl = res.data[0] || "";
        this.$refs.companyAuthForm.validateField("corporationPhotoPath");
      });
    },
    /**
     * @description 修改时要点击修改，输入框才能编辑
     */
    openEdit() {
      this.isCompanyEdit = false;
    },
    /**
     * @description 修改时要点击返回，重新请求数据，按钮输入框不可编辑
     */
    backStep() {
      this.isCompanyEdit = this.companyEdit;
      // 恢复表单默认值， 再去请求
      this.$emit("pageActive");
    },
    /**
     * @description 提交
     */
    submit() {
      this.$refs.companyAuthForm.validate((valid) => {
        if (valid) {
          let newParams = {
            socialCreditCode: this.companyAuthForm.socialCreditCode,
            businessLicensePath: this.companyAuthForm.businessLicensePath,
            corporationName: this.companyAuthForm.corporationName,
            corporationCardId: this.companyAuthForm.corporationCardId,
            // corporationProvinceId:
            //   this.companyAuthForm.corporationProvinceId,
            // corporationProvinceName:
            //   this.companyAuthForm.corporationProvinceName,
            // corporationCityId:
            //   this.companyAuthForm.corporationCityId,
            // corporationCityName:
            //   this.companyAuthForm.corporationCityName,
            corporationProvinceId:
              this.companyAuthForm.receiveAddress.corporationProvinceId,
            corporationProvinceName:
              this.companyAuthForm.receiveAddress.corporationProvinceName,
            corporationCityId:
              this.companyAuthForm.receiveAddress.corporationCityId,
            corporationCityName:
              this.companyAuthForm.receiveAddress.corporationCityName,
            corporationAreaId:
              this.companyAuthForm.receiveAddress.corporationAreaId,
            corporationAreaName:
              this.companyAuthForm.receiveAddress.corporationAreaName,
            corporationDetailedAddress:
              this.companyAuthForm.corporationDetailedAddress,
            corporationPhotoPath: this.cardList.join(","),
            userId: this.user.id,
          };
          // this.auditStatus 0-刚提交开发者认证 this.companyEdit为true 表明之前就有企业消息
          this.$API.companyCerCommit(newParams).then((res) => {
            if (res.code === RESPONSE_SUCCESS) {
              this.$alert(
                this.$lang('请等待1-2个工作日，并留意审核结果。'),
                this.$lang("信息提交成功"),
                {
                  confirmButtonText: this.$lang("确定"),
                  closeOnClickModal: false,
                  type: "success",
                  confirmButtonClass: "comfirm-btn",
                }
              );
              this.$emit("companyAuthSuccess");
              this.isCompanyEdit = this.companyEdit;
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    validateCardPath(rule, value, callback) {
      //  idCardImageUrl:"",//身份证正面照片
      //idCardBackImageUrl:"",//身份证反面照片
      if (this.idCardImageUrl === "") {
        callback(new Error(this.$lang("请上传身份证正面照片")));
      } else if (this.idCardBackImageUrl === "") {
        callback(new Error(this.$lang("请上传身份证反面照片")));
      } else {
        callback();
      }
    },
    receiveAddress(rule, value, callback) {
      if (this.companyAuthForm.receiveAddress === "") {
        callback(new Error(this.$lang("请选择输入地址")));
        return;
      }
      const {
        corporationProvinceName,
        corporationCityName,
        // corporationAreaName,
      } = this.companyAuthForm.receiveAddress;

      if (
        corporationProvinceName == "" ||
        corporationCityName == "" 
      ) {
        callback(new Error(this.$lang("请选择输入地址")));
      } else {
        callback();
      }
    },
    // receiveAddress(rule, value, callback) {
    //   const {
    //     corporationProvinceName,
    //     corporationCityName,
    //   } = this.companyAuthForm

    //   if (
    //     corporationProvinceName == "" ||
    //     corporationCityName == "" 
    //   ) {
    //     callback(new Error(this.$lang("请选择输入地址")));
    //   } else {
    //     callback();
    //   }
    // },
    /**
     * @description 酋长国变化
     */
    dataProvinceChange(value) {
      this.getCityList(value)
    },
    /**
     * @description 区域变化
     */
    dataCityChange(value) {
      this.companyAuthForm.corporationCityId = value
      const obj = this.cityList.find((item) => {
        return item.id === value
      })
      this.companyAuthForm.corporationCityName = obj.nativeName
    },
    // 获取数据
    async getCityList(parentId) {
      let params = {
        parentId: parentId,
        type: "3",
      };
      const formData = new FormData();
      Object.keys(params).forEach((key) => {
        formData.append(key, params[key]);
      });
      this.$API.areaList(formData).then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          // 区域获取列表
          this.cityList = [...res.data]
          this.companyAuthForm.corporationProvinceId = parentId
          if(res.data && res.data.length > 0) {
            this.companyAuthForm.corporationCityId = res.data[0].id
            this.companyAuthForm.corporationCityName = res.data[0].nativeName
          } else {
            this.companyAuthForm.corporationCityId = ''
            this.companyAuthForm.corporationCityName = ''
          }
          console.log(this.companyAuthForm.corporationCityId, 1)
          console.log(this.companyAuthForm.corporationCityName, 2)
          let obj = {}
          obj = this.provinceArray.find((item) => {
            return item.id === parentId
          })
          this.companyAuthForm.corporationProvinceName = obj.nativeName
        } else {
          this.$message.error(res.msg);
        }
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.companyAuth {
  position: relative;
  h3 {
    font-size: 22px;
    color: #2b2d42;
    line-height: 22px;
    margin-bottom: 20px;
    .iconfont {
      color: $theme-color;
      font-size: 24px;
      margin-right: 16px;
      font-weight: normal;
    }
  }
  .audit-status {
    position: absolute;
    right: 0;
    top: -15px;
    font-size: 14px;
    text-align: right;
    .iconfont {
      margin-right: 6px;
      font-size: 14px;
    }
    .iconshenhezhuangtai_weishenqingshibai {
      color: #e60012;
    }
    .iconshenhezhuangtai_shenhezhong {
      color: rgb(45, 124, 255);
    }
    .iconshenhezhuangtai_tongguo {
      color: rgb(34, 206, 136);
    }
    span {
      color: #e60012;
    }
  }
  .avatar-uploader {
    width: 200px;
    height: 113px;
    border: 1px dashed #c4c8cc;
    border-radius: 4px;
    position: relative;
    box-sizing: border-box;
  }
  .upload {
    width: 200px;
    height: 113px;
    position: relative;
    box-sizing: border-box;
    display: inline-block;
    &.ml20{
      margin-left: 20px;
    }
    .text {
      position: absolute;
      top: 63px;
      left: 97px;
      height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: #a1a3a6;
      line-height: 17px;
      transform: translate(-50%, -50%);
    }
  }
  .upload-dec {
    height: 16px;
    font-size: 12px;
    font-weight: 400;
    color: #c4c8cc;
    line-height: 16px;
    .iconicotishi {
      font-size: 12px;
      color: #2d7cff;
      cursor: pointer;
    }
  }
  // 商业执照示例弹窗
  .address {
    position: relative;
    .example-business {
      position: absolute;
      top: 0;
      left: 260px;
      width: 345px;
      background: #ffffff;
      border: 1px solid #dcdee1;
      box-shadow: 0px 0px 10px 0px rgba(209, 213, 223, 0.5);
      box-sizing: border-box;
      padding: 20px;
      z-index: 99;
      .img-box {
        width: 100px;
        height: 100px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .explain {
        width: 299px;
        font-size: 12px;
        color: #9499a3;
        line-height: 20px;
        margin-top: 10px;
      }
      &::after {
        content: "";
        width: 8px;
        height: 8px;
        transform: rotate(-135deg);
        border-width: 1px;
        border-style: solid;
        border-color: #dcdee1 #dcdee1 #fff #fff;
        position: absolute;
        top: 129px;
        left: -5px;
        z-index: 99;
        background: #fff;
      }
    }
    .example-id {
      position: absolute;
      bottom: -30px;
      left: 260px;
      width: 345px;
      background: #ffffff;
      border: 1px solid #dcdee1;
      box-shadow: 0px 0px 10px 0px rgba(209, 213, 223, 0.5);
      box-sizing: border-box;
      padding: 20px;
      z-index: 99;
      .img-box {
        width: 220px;
        height: 62px;
        box-sizing: border-box;
        img {
          width: 47%;
          height: 100%;
        }
        &::after {
          content: "";
          width: 8px;
          height: 8px;
          transform: rotate(-135deg);
          border-width: 1px;
          border-style: solid;
          border-color: #dcdee1 #dcdee1 #fff #fff;
          position: absolute;
          bottom: 34px;
          left: -5px;
          z-index: 99;
          background: #fff;
        }
      }
      .explain {
        width: 287px;
        font-size: 12px;
        color: #9499a3;
        line-height: 20px;
        margin-top: 10px;
      }
    }
    .example-id2 {
      position: absolute;
      top: -50px;
      left: 260px;
      width: 345px;
      height: 212px;
      background: #ffffff;
      border: 1px solid #dcdee1;
      box-shadow: 0px 0px 10px 0px rgba(209, 213, 223, 0.5);
      box-sizing: border-box;
      padding: 20px;
      z-index: 99;
      .img-box {
        width: 220px;
        height: 62px;
        box-sizing: border-box;
        img {
          width: 47%;
          height: 100%;
        }
        &::after {
          content: "";
          width: 8px;
          height: 8px;
          transform: rotate(-135deg);
          border-width: 1px;
          border-style: solid;
          border-color: #dcdee1 #dcdee1 #fff #fff;
          position: absolute;
          top: 180px;
          left: -5px;
          z-index: 99;
          background: #fff;
        }
      }
      .explain {
        width: 287px;
        height: 78px;
        font-size: 12px;
        font-weight: 400;
        color: #9499a3;
        line-height: 20px;
        margin-top: 10px;
      }
    }
  }

  .nextStep {
    width: 450px;
    height: 40px;
    background-color: $theme-color;
    color: #fff;
    font-size: 14px;
    margin-left: 180px;
    margin-top: 8px;
  }
  .back {
    width: 215px;
    height: 40px;
    border: 1px solid #b0b3b6;
    border-radius: 4px;
    color: #61666d;
    font-weight: 400;
    margin-left: 180px;
  }
  .save {
    width: 215px;
    height: 40px;
    background-color: $theme-color;
    border-radius: 4px;
    color: #ffffff;
    margin-left: 20px;
  }
  // 英语语言下的class
  &.en{
    .example-business {
      top: 150px;
      &::after {
        border-color: #fff #dcdee1 #dcdee1  #fff;
        top: -5px;
        left: 131px;
      }
    }
    .example-id {
      bottom: 25px;
      .img-box {
        &::after {
          border-color:  #dcdee1 #fff #fff #dcdee1;
          bottom: -5px;
          left: 130px;
        }
      }
    }
    .example-id2 {
      height: 240px;
      top: -120px;
      .img-box {
        &::after {
          border-color:  #dcdee1 #fff #fff #dcdee1;
          top: 234px;
          left: 135px;
        }
      }
    }
  }
}
.companyAuth::v-deep {
  .el-form-item {
    .el-form-item {
      margin-bottom: 0 !important;
    }
    .el-form-item.nth-2 {
      margin-left: 20px;
    }
  }
  .el-input input:hover {
    border-color: $theme-color;
  }
  .el-upload {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    img {
      width: 100%;
      height: 100%;
    }
    .avatar-uploader-icon {
      position: relative;
      top: 24px;
    }
  }
}

[dir="rtl"] .companyAuth {
  .address {
    .example-business {
      left: inherit;
      right: 42px;
      text-align: right;
      &::after {
        left: inherit;
        right: -5px;
        border-color: #fff #fff #dcdee1 #dcdee1;
      }
    }
    .example-id {
      left: inherit;
      right: 42px;
      text-align: right;
      .img-box::after {
        left: inherit;
        right: -5px;
        border-color: #fff #fff #dcdee1 #dcdee1;
      }
    }
  }
   .upload {
    &.ml20{
      margin-left: 0;
      margin-right: 20px;
    }
   }
   .nextStep{
     margin-left: 0px;
     margin-right: 180px;
   }
}
</style>
